export const PAYMENT_METHOD = {
    CASH: 'cash',
    CREDIT_CARD: 'credit_card',
    DEBIT_CARD: 'debit_card',
    BANK_TRANSFER: 'bank_transfer',
    OTHER: 'other',
} as const;

export type PaymentMethod = Enum<typeof PAYMENT_METHOD>;
